module.exports = __webpack_public_path__ + "vn.svg?57857a74f1b844d3489643a021afd0b9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/vn.svg
// module id = 974
// module chunks = 27